
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "responsive-props"
    }}>{`Responsive props`}</h1>
    <p>{`It's common when working on mobile-first designs to have styling that differs between breakpoints. To make it easier to implement these designs, all system props, and custom props defined with styled-system's `}<inlineCode parentName="p">{`styled`}</inlineCode>{` utility, can accept an object that specifies what value to use at each breakpoint.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`If we want a box that has extra-large margins at all breakpoints, we can define it this way:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Box m="xl">
`}</code></pre>
    <p>{`If we want a box that has medium margins at the `}<inlineCode parentName="p">{`xs`}</inlineCode>{` breakpoint (mobile), and large margins at the `}<inlineCode parentName="p">{`sm`}</inlineCode>{` breakpoint and above, we can define it like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Box m={{ xs: 'm', sm: 'l' }}>
`}</code></pre>
    <p>{`Breakpoint screen widths are defined in our `}<a parentName="p" {...{
        "href": "/theme"
      }}>{`theme`}</a>{`.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://styled-system.com/responsive-styles"
      }}>{`styled-system's docs`}</a>{` for more info.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;